module.exports = __webpack_public_path__ + "static/media/fish.b5262e54.png";